import { Table } from 'components/table'
import { IProjectExecutionDTO } from 'data/dtos/automation/i-project-execution-dto'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { ChangeEvent, MouseEvent, useEffect, useState } from 'react'
import api from 'services/api'
import { useAlreadyMounted } from 'utils/use-already-mounted'
import { useStyles } from './styles'

const headCells: ITableHeadDTO[] = [
  {
    id: 'name',
    label: 'Nome',
    width: 4,
    type: 'text',
  },
  {
    id: 'corporateName',
    label: 'Seller',
    width: 3,
    type: 'text',
  },
  {
    id: 'corporateName',
    label: 'Buyer',
    width: 2,
    type: 'text',
  },
]

const ProjectExecutionList: React.FC = () => {
  const [page, setPage] = useState<number>(0)
  const [search, setSearch] = useState<string>('')
  const [rowsCount, setRowsCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [rowsPerPage, setRowsPerPage] = useState<number>(100)
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false)
  const [columnOrder, setColumnOrder] = useState<('ASC' | 'DESC')[]>([])
  const [recordToDelete, setRecordToDelete] = useState<string | null>('')
  const [orderByDirection, setOrderByDirection] = useState<boolean>(true)
  const [projectExecutionsList, setProjectExecutionsList] = useState<IProjectExecutionDTO[]>([])

  const classes = useStyles()
  const alreadyMounted = useAlreadyMounted()

  const loadProjectExecutions = async (isSearch?: boolean) => {
    if (!isSearch) {
      setIsLoading(true)
    }

    await api
      .post('/project-executions/list', { search, page, rowsPerPage, columnOrder })
      .then((response) => setProjectExecutionsList(response.data.data))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    await api
      .post('/project-executions/count', { search })
      .then((response) => setRowsCount(response.data.data.count))
      .catch((error) => {
        setIsLoading(false)
        console.log(error)
      })

    setIsLoading(false)
  }

  const handleDelete = async () => {
    await api
      .delete(`/project-executions/${recordToDelete}`)
      .then(async () => await loadProjectExecutions())
      .catch((error) => console.log(error.response?.data))
  }

  const searchChange = (value: string) => {
    setSearch(value)
  }

  const handleClose = () => {
    setModalIsOpen(false)
  }

  const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    event!.preventDefault()
    setPage(newPage)
  }

  const handleChangeRowsPerPage = async (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleCloseDelete = () => {
    setModalIsOpen(false)
    handleDelete()
  }

  const handleDeleteButton = (e: MouseEvent<any, any>, id: string) => {
    e.stopPropagation()
    setModalIsOpen(true)
    setRecordToDelete(id)
  }

  const handleSortChange = (index: number) => {
    columnOrder[index] = columnOrder[index] === 'ASC' ? 'DESC' : 'ASC'

    setColumnOrder(columnOrder)
    setOrderByDirection(!orderByDirection)
  }

  const tabOptions = [
    {
      title: 'Todas',
      size: rowsCount,
      handleClick: () => {},
    },
  ]

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!alreadyMounted) {
        loadProjectExecutions()
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [search])

  useEffect(() => {
    loadProjectExecutions()
  }, [orderByDirection, rowsPerPage, page])

  return (
    <Table.Root>
      <Table.Info
        title='Execuções de Projetos'
        route='/project-executions/new'
        subTitle='Dados coletados sobre as execuções dos projetos de automação.'
      />

      <Table.tabs options={tabOptions} />
      <Table.SearchBar
        value={search}
        handleChange={searchChange}
      />

      <Table.Overlay
        isEmpty={projectExecutionsList.length <= 0}
        isSearch={search.length > 0}
        isLoading={isLoading}
        route='/project-executions/new'
        emptyRouteText='Adicionar project_execution'
        searchRouteText='Adicionar project_execution'
        searchMessage='Nenhum project_execution encontrado, você pode criar um novo project_execution clicando no botão'
        emptyMessage='Seja bem-vindo à página de gerenciamento de ProjectExecutionss. Até o momento, nenhum project_execution foi criado. Para começar, você pode criar um novo project_execution clicando no botão'
      >
        <Table.Wrapper
          totalRows={rowsCount}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          page={page}
          handleClose={handleClose}
          handleCloseDelete={handleCloseDelete}
          modalIsOpen={modalIsOpen}
        >
          <Table.Header
            handleSortChange={handleSortChange}
            setOrder={setColumnOrder}
            headCells={headCells}
            order={columnOrder}
          />
          <Table.Body
            handleDeleteButton={handleDeleteButton}
            editRoutePath='/project-executions/edit'
            headCells={headCells}
            rows={projectExecutionsList}
          />
        </Table.Wrapper>
      </Table.Overlay>
    </Table.Root>
  )
}

export default ProjectExecutionList
